module.exports = __webpack_public_path__ + "static/media/public.a518ad37.svg";